export default function Connection (props) {

    return (
        <svg className={props.className} style={props.style} stroke={props.stroke || '#000'} xmlns="http://www.w3.org/2000/svg" viewBox="-1.24264 2.75736 24.49 24.49">
            <path d="M 7 13 L 3 17 A 2 2 90 0 0 9 23 L 13 19 M 8 18 L 14 12 M 9 11 L 13 7 A 2 2 90 0 1 19 13 L 15 17" strokeWidth="3" fill="none"/>
        </svg>
    )

}